module.exports = __webpack_public_path__ + "img/e160cb0.jpg";